import React from 'react'
import Popup from '../../Components/Popup';

export default function VideoPopup({ videoShow, setVideoShow, PreviewVideo }) {
    const modalbody = (
        <iframe
            width="500"
            height="500"
            src={PreviewVideo}
            frameborder="0"
            allowfullscreen
        ></iframe>
    )
    return (
        <Popup isshow={videoShow} size={"lg"} title={"Preview Video"}
            closePopup={(e) => { setVideoShow(false) }}
            modalBody={modalbody} visibleSaveBtn={false} />
    )
}
